import { img } from "../../data/salon";
import { useScrollScrub } from "../../lib/motion";
import "./ui.css";

/**
 * Photography primitive. `scrub` adds scroll-linked parallax inside the
 * frame; `reveal` wipes the image in behind a clip-path as it enters.
 */
export default function Photo({
  src,
  alt = "",
  ratio = "3 / 4",
  className = "",
  scrub = false,
  reveal = false,
  tint = "none",
  priority = false,
  children,
}) {
  const ref = useScrollScrub();

  // baskets persisted before photography existed carry no key
  if (!src) return null;

  return (
    <figure
      ref={scrub || reveal ? ref : undefined}
      className={`ph${scrub ? " ph--scrub" : ""}${reveal ? " ph--reveal" : ""} ph--tint-${tint} ${className}`}
      style={{ "--ratio": ratio }}
    >
      <img
        src={img(src)}
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        draggable="false"
      />
      <span className="ph__tint" aria-hidden="true" />
      {children}
    </figure>
  );
}
